// Get jQuery from global scope
const $ = window.jQuery;

$(document).ready(function () {


  $('.image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true
  });

  // Cache selectors
  var $owlCarousel = $(".owl-carousel");

  if ($owlCarousel.length) {
    try {
      $owlCarousel.slick({
        slidesToShow: 1,
        vertical: false,
        arrows: true,
        dots: false,
        autoplay: true,
        adaptiveHeight: false, // Changed to false to prevent forced reflows
        prevArrow:
          '<button class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none"><path d="M20 10.1117L18.225 11.8867L10 3.66172L1.775 11.8867L0 10.1117L10 0.111718L20 10.1117Z" fill="#151820"/></svg></button>', // Custom previous button
        nextArrow:
          '<button class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none"><path d="M20 1.88828L18.225 0.113281L10 8.33828L1.775 0.113281L0 1.88828L10 11.8883L20 1.88828Z" fill="#151820"/></svg></button>', // Custom next button
      });
    } catch (error) {
      console.warn("Owl carousel slider initialization failed:", error);
    }
  }

  // Related Case Studies slider for mobile
  var $relatedCaseStudies = $(".related-case-studies__cases--slider");

  if ($relatedCaseStudies.length) {
    try {
      $relatedCaseStudies.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        adaptiveHeight: false, // Changed to false to prevent forced reflows
        mobileFirst: true,
        centerMode: false,
        variableWidth: false,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="#3978CF" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick", // Disable slider on tablet and desktop
          },
        ],
      });
    } catch (error) {
      console.warn("Related case studies slider initialization failed:", error);
    }
  }

  // Related Blog Posts slider (only when more than 4 posts)
  var $blogPostsSlider = $(".blog-related-block__posts--slider");

  if ($blogPostsSlider.length) {
    try {
      $blogPostsSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        infinite: true,
        adaptiveHeight: false, // Changed to false to prevent forced reflows
        mobileFirst: true,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: "unslick", // Disable slider on desktop
          },
        ],
      });
    } catch (error) {
      console.warn("Blog posts slider initialization failed:", error);
    }
  }

  // Related Blog Posts - All posts get mobile slider
  var $blogPosts = $(".blog-related-block__posts");

  if ($blogPosts.length) {
    try {
      $blogPosts.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: false,
        infinite: true,
        adaptiveHeight: false, // Changed to false to prevent forced reflows
        mobileFirst: true,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next blog post"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: "unslick", // Disable slider on desktop
          },
        ],
      });
    } catch (error) {
      console.warn("Blog related posts slider initialization failed:", error);
    }
  }

  // Case Studies Carousel
  var $caseStudiesCarousel = $(".case-studies-carousel__slider");
  if ($caseStudiesCarousel.length) {
    $caseStudiesCarousel.each(function () {
      var $slider = $(this);
      var slideCount = $slider.children().length;

      // Need at least 2 slides to make a carousel meaningful; otherwise leave the
      // slides as a static row. With infinite:true Slick will loop even when
      // slideCount < slidesToShow.
      if (slideCount < 2 || !$slider.length) {
        return;
      }

      var $arrows = $slider
        .closest(".case-studies-carousel")
        .find(".case-studies-carousel__arrows");

      // Add active classes on init and after change
      function updateActiveClasses() {
        // Use requestAnimationFrame to batch DOM operations and prevent forced reflows
        requestAnimationFrame(function () {
          $slider
            .find(".slick-slide")
            .removeClass("active-1 active-2 active-3 active-4");
          $slider.find(".slick-active").each(function (index) {
            $(this).addClass("active-" + (index + 1));
          });
        });
      }

      $slider.on("init afterChange", updateActiveClasses);

      // Slick disables infinite/arrows when slideCount <= slidesToShow, so clamp
      // slidesToShow to (slideCount - 1) when the count is small. This guarantees
      // there's always at least one off-screen slide for the arrows to scroll to.
      //
      // Dropped from 5 to 4 across: at 5 the cards were too small to carry the
      // imagery (BugHerd #78, "I don't mind if less are shown"). Each card gains
      // ~25% width. Tune here rather than in SCSS — the slide width is derived.
      var slidesToShow = slideCount > 4 ? 4 : Math.max(1, slideCount - 1);

      try {
        $slider.slick({
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          adaptiveHeight: false,
          appendArrows: $arrows.length ? $arrows : undefined,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next case study"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                centerPadding: "20%",
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn("Case studies carousel initialization failed:", error);
      }
    });
  }

  // Team Slider Block
  var $teamSlider = $(".team-slider-block__slider");
  if ($teamSlider.length && $teamSlider.children().length > 0) {
    var $arrows = $teamSlider
      .closest(".team-slider-block__slider-wrapper")
      .find(".team-slider-block__arrows");
    var slideCount = $teamSlider.children().length;

    try {
      $teamSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1500,
        infinite: true,
        adaptiveHeight: false,
        appendArrows: $arrows.length ? $arrows : undefined,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous team member"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next team member"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 2560,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            },
          },
        ],
      });
    } catch (error) {
      console.warn("Team slider initialization failed:", error);
    }
  }

  // Logos Block Slider (only when more than 3 logos)
  var $logosBlockSliders = $(".logos-block__slider");
  if ($logosBlockSliders.length) {
    $logosBlockSliders.each(function () {
      var $logosSlider = $(this);

      // Check if slider has children before initializing
      if (!$logosSlider.length || $logosSlider.children().length === 0) {
        return;
      }

      try {
        $logosSlider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          infinite: true,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn("Logos block slider initialization failed:", error);
      }
    });
  }

  // Logos Block Mobile Slider (<= 3 logos, active below 768px only)
  function initLogosBlockMobile() {
    var $logosBlockMobile = $(".logos-block--mobile");
    if (!$logosBlockMobile.length) return;

    $logosBlockMobile.each(function () {
      var $slider = $(this);

      if (!$slider.length || $slider.children().length <= 1) {
        return;
      }

      if (window.innerWidth < 768) {
        if (!$slider.hasClass("slick-initialized")) {
          try {
            $slider.slick({
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 1000,
              infinite: true,
              adaptiveHeight: false,
              responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          } catch (error) {
            console.warn("Logos block mobile slider initialization failed:", error);
          }
        }
      } else {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
      }
    });
  }

  initLogosBlockMobile();
  $(window).on("resize", function () {
    initLogosBlockMobile();
  });

  // Testimonials Slider
  var $testimonialSlider = $(".testimonials-block__testimonials");
  if ($testimonialSlider.length && $testimonialSlider.children().length > 0) {
    var $arrows = $testimonialSlider
      .closest(".testimonials-block__slider-wrapper")
      .find(".testimonials-block__arrows");

    try {
      $testimonialSlider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 10000,
        infinite: true,
        focusOnSelect: true,
        speed: 600,
        appendArrows: $arrows.length ? $arrows : undefined,
        prevArrow:
          '<button class="slick-prev testimonials-prev" aria-label="Previous testimonial"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_5238_17)"><rect width="24" height="24" rx="1" transform="matrix(-1 0 0 1 24 0)" fill="#99E5B2"/><path d="M13.5 15L10.5 12L13.5 9" stroke="#071B2B" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5238_17"><path d="M24 5C24 2.23858 21.7614 0 19 0H5C2.23857 0 0 2.23858 0 5V19C0 21.7614 2.23858 24 5 24H19C21.7614 24 24 21.7614 24 19V5Z" fill="white"/></clipPath></defs></svg></button>',
        nextArrow:
          '<button class="slick-next testimonials-next" aria-label="Next testimonial"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_5238_131)"><rect width="24" height="24" rx="1" fill="#99E5B2"/><path d="M10.5 15L13.5 12L10.5 9" stroke="#071B2B" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5238_131"><path d="M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z" fill="white"/></clipPath></defs></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerPadding: "0",
            },
          },
        ],
      });
    } catch (error) {
      console.warn("Testimonials slider initialization failed:", error);
    }
  }

  // Inner Hero Logos Slider (below 1200px only)
  var $innerHeroLogos = $(".inner-hero-block__logos");
  if ($innerHeroLogos.length && $(window).width() < 1200) {
    $innerHeroLogos.each(function () {
      var $slider = $(this);

      // Check if slider has children before initializing
      if (!$slider.length || $slider.children().length === 0) {
        return;
      }

      try {
        $slider.slick({
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          adaptiveHeight: false,
          pauseOnHover: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: 'unslick',
            },
          ],
        });
      } catch (error) {
        console.warn("Inner hero logos slider initialization failed:", error);
      }
    });
  }

  // Logo Text Block Slider (1024px to 1600px only) and Inner Hero Block Logos
  // Initialize early to prevent CLS
  var $logoSliders = $(
    ".logo-text-block__logos, .logo-text-block__logos--slider",
  );
  if ($logoSliders.length) {
    $logoSliders.each(function () {
      var $logoSlider = $(this);

      // Check if slider has children before initializing
      if (!$logoSlider.length || $logoSlider.children().length === 0) {
        return;
      }

      try {
        // Show immediately before initialization
        $logoSlider.css("visibility", "visible");

        $logoSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 1000,
          infinite: true,
          adaptiveHeight: false,
          pauseOnHover: false,
          lazyLoad: "ondemand", // Lazy load images to improve performance
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1615,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } catch (error) {
        console.warn("Logo text block slider initialization failed:", error);
      }
    });
  }

  // 12. USP Banner Slider
  function initUspBannerSlider() {
    var $uspSliders = $(".usp-banner__slider");
    if ($uspSliders.length) {
      $uspSliders.each(function () {
        var $slider = $(this);
        var slideCount = $slider.children().length;

        if (!slideCount || $slider.hasClass("slick-initialized")) {
          return;
        }

        // More than 3 USPs: Slide on both desktop and mobile
        if (slideCount > 3) {
          try {
            $slider.slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 2500,
              speed: 500,
              infinite: true,
              adaptiveHeight: false,
              pauseOnHover: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          } catch (error) {
            console.warn("USP banner slider initialization failed:", error);
          }
        } else if (slideCount > 1) {
          // 3 or fewer USPs: Slide on mobile only, unslick on desktop
          try {
            $slider.slick({
              mobileFirst: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              autoplay: true,
              autoplaySpeed: 2500,
              speed: 500,
              infinite: true,
              adaptiveHeight: false,
              pauseOnHover: true,
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 1024,
                  settings: "unslick",
                },
              ],
            });
          } catch (error) {
            console.warn("USP banner mobile slider initialization failed:", error);
          }
        }
      });
    }
  }
  initUspBannerSlider();

  // Window resize handler to re-initialize unslicked sliders when resizing back down to mobile
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(window).width() < 1024) {
        initUspBannerSlider();
      }
    }, 200);
  });

}); // End of document.ready
